/**
 * Greeting derivation shared by the applicant dashboard (web) and the
 * mobile dashboard screen.
 *
 * Applies the three-step preference chain for first name (Requirement 8 of
 * the structured-name-identity feature):
 *
 *   1. Prefer `user.firstName` when present and non-empty.
 *   2. Fall back to `fullName.split(' ')[0]` for legacy sessions that
 *      predate structured names in the id token.
 *   3. Fall back to the generic `"Applicant"` label when nothing usable is
 *      available.
 *
 * Pure function (no React dependencies) so it can be exercised by property
 * tests and shared across platforms.
 */
export function deriveGreetingFirstName(user: {
  firstName?: string | null;
  fullName?: string | null;
} | null | undefined): string {
  if (user?.firstName && user.firstName.length > 0) {
    return user.firstName;
  }
  if (user?.fullName) {
    const part = user.fullName.split(' ')[0];
    if (part && part.length > 0) return part;
  }
  return 'Applicant';
}
